import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'kabas-legals-page-ai',
  templateUrl: './legals-page-ai.component.html',
})
export class LegalsPageAiComponent {}
